import React, { useEffect, useState } from 'react'
// import {
//   deleteCategoriesServer,
//   getCategoriesServer
// } from '../../../apis/categoriesApi'
import { Table } from 'antd'
// import getCategoriesColumns from '../../../const/Columns/getCategoryColumns'
import { Link } from 'react-router-dom'
import getCategoriesColumns from '../../../const/columns/getCategoryColumns'
import { deleteCategoriesServer, getCategoriesServer } from '../../../apis/categoryApi'

const Category = () => {
  const [category, setCategory] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchCategory()
  }, [])

  const fetchCategory = async () => {
    try {
      const res = await getCategoriesServer()
      setCategory(res.result)
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const deleteCategory = async id => {
    const isConfirmed = window.confirm(
      'Are you sure you want to delete this Category?'
    )
    if (isConfirmed) {
      await deleteCategoriesServer(id)
      setLoading(true)
      fetchCategory()
    }
  }
  const columns = getCategoriesColumns(deleteCategory)
  return (
    <>
      <div className='main-wrapper'>
        <div className='page-wrapper'>
          <div className='content container-fluid'>
            <div className='d-flex  justify-content-between  align-items-center'>
              <Link to='/addCategory' className='btn add-new btn-primary mb-3'>
                Add Category
              </Link>
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className='table-respoinsive'>
                <Table
                  columns={columns}
                  dataSource={category?.length > 0 ? category : []}
                  className='table-striped '
                  rowKey={record => record.id}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Category
